<template lang="pug">
div
  validation-provider(:rules="''", v-slot="{ errors }", name="Peça Tecnica/Geometria")
    keep-alive
      pecaTecnica(
        :cadastroColetivo="copiaCadastroColetivo"
        @onRemoveGeometria="onRemoveGeometria",
        @atualizarPecaTecnica="atualizarPecaTecnica"
        @validacaoDocumentos="validacaoDocumentos"
      )
  div
    .wrap-collabsible(v-if="despachosFormatados.length")
    divider(label="Histórico de despachos" v-if="despachosFormatados.length")
    el-collapse
      el-collapse-item(v-for="despacho in despachosFormatados" :key="despacho.dataCriacao" :title="`Análise ${despacho.setor}`" :name="despacho.dataCriacao")
        Informacoes-analise(
          :responsavel="despacho.usuario.pessoa.nomeRazaoSocial",
          :cargo="despacho.perfil",
          :data="despacho.dataCriacao"
        )
        div
          divider(label="Despacho")
          div.mt-1.padding-info-analise
          el-row
            p.input(v-html="despacho.texto")
        div(v-if="despacho.documento")
          divider(label="Anexo")
          div.arquivos(v-if="despacho.documento")
            app-download-arquivo(
              :arquivo="despacho.documento"
              @download="download(despacho.documento)"
            )

</template>

<script>
import InformacoesAnalise from '@/screens/arrecadacao/components/InformacoesAnalise'
import Divider from '@/screens/arrecadacao/components/Divider'
import PecaTecnica from '@/screens/arrecadacao/gat/components/PecaTecnica'
import AppDownloadArquivo from '@/components/AppDownloadArquivo'
import VisualizarCadastroColetivo from '@/screens/arrecadacao/components/VisualizarCadastroColetivo'
import { mapActions } from 'vuex'
import FileHelper from '@/utils/fileHelper'

const PECA_TECNICA_EMPTY = {
  area: null,
  perimetro: null,
  geom: null,
  municipios: []
}

export default {
  components: {
    InformacoesAnalise,
    AppDownloadArquivo,
    Divider,
    VisualizarCadastroColetivo,
    PecaTecnica
  },

  props: {
    despachos: { required: true, type: Array },
    cadastroColetivo: { required: true, type: Object }
  },

  data () {
    return {
      despachosFormatados: [],
      copiaCadastroColetivo: null
    }
  },

  async created () {
    this.copiaCadastroColetivo = this.cadastroColetivo
  },

  methods: {
    ...mapActions({
      downloadDocumentos: 'documentoArrecadacao/download',
      findByIdCadastroColetivo: 'cadastroColetivo/findById'
    }),

    async download (documento) {
      const arrayBuffer = await this.downloadDocumentos({
        fileKey: documento.fileKey,
        id: documento.id
      })

      FileHelper.saveFile(arrayBuffer, documento.nomeOriginal)
    },
    formataDespachos () {
      this.despachosFormatados = this.$props.despachos.map(despacho => {
        if (despacho.documento) {
          return {
            ...despacho,
            documento: {
              ...despacho.documento,
              nome: despacho.documento.nomeOriginal
            }
          }
        } else {
          return despacho
        }
      })
    },
    mergePecaTecnica (geo) {
      const idGeo = this.cadastroColetivo.pecaTecnica.id

      this.cadastroColetivo.pecaTecnica = geo
      this.cadastroColetivo.pecaTecnica.id = idGeo

      this.copiaCadastroColetivo = this.cadastroColetivo
    },

    validacaoDocumentos (documentos) {
      this.$emit('validacaoDocumentos', documentos)
    },

    onRemoveGeometria () {
      this.mergePecaTecnica(PECA_TECNICA_EMPTY)
    },

    async atualizarPecaTecnica (geo) {
      await this.mergePecaTecnica(geo)
    }
  },

  watch: {
    despachos: {
      async handler () {
        if (this.despachos.length) {
          this.formataDespachos()
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';
>>> .el-collapse-item__header {
  font-size: 17px;
}

.wrap-collabsible {
  margin-bottom: 1.2rem 0;
}

input[type='checkbox'] {
  display: none;
}

.lbl-toggle {
  display: block;

  font-weight: bold;
  font-size: 17px;
  font-weight: 500;
  color: #303133;

  cursor: pointer;

  border-radius: 7px;
  transition: all 0.3s ease-out;

  height: 48px;
  line-height: 48px;
  label {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
  }
}

.icon {
  transition: transform 0.3s ease-out;
}

.toggle:checked + .lbl-toggle {
  i {
    transform: rotate(90deg) translateX(-3px);
  }
}

.collapsible-content {
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.3s;
}

.toggle:checked + .lbl-toggle + .collapsible-content {
  max-height: 200vh;
  padding-bottom: 25px;
}

.toggle:checked + .lbl-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/components/ValidacaoEdicaoCadastro.vue